var map = {
	"./MoneyIcon.jsx": 4976,
	"./PatientIcon.jsx": 3931,
	"./PlusIcon.jsx": 796,
	"./PlusIcon32.jsx": 1495,
	"./SurgeryIcon.jsx": 7241,
	"./TripIcon.jsx": 8269,
	"./TripIcon2.jsx": 7371,
	"./TripIcon24.jsx": 6971,
	"./accessibilityIcon.jsx": 944,
	"./addAccont.jsx": 6994,
	"./addAccont24.jsx": 3248,
	"./addGroupIcon.jsx": 7874,
	"./addPatientIcon.jsx": 272,
	"./addPhotoIcon.jsx": 2135,
	"./addProject.jsx": 1107,
	"./addUserIcon.jsx": 5772,
	"./adminIcon.jsx": 4573,
	"./allergyIcon.jsx": 888,
	"./avatarIcon.jsx": 1027,
	"./bloodType.jsx": 8203,
	"./bookmark.jsx": 2131,
	"./bookmarkIcon.jsx": 1496,
	"./borderIcon.jsx": 9370,
	"./calendarIcon.jsx": 2246,
	"./calendarIcon24.jsx": 9324,
	"./callIcon.jsx": 8348,
	"./clockIcon.jsx": 2142,
	"./closeIcon.jsx": 4276,
	"./collapseIcon.jsx": 5025,
	"./companyIcon.jsx": 2453,
	"./configIcon.jsx": 2862,
	"./dashboard.jsx": 3539,
	"./dayIcon.jsx": 4210,
	"./deleteIcon.jsx": 9577,
	"./dentalIcon.jsx": 8488,
	"./descriptionIcon.jsx": 6950,
	"./downArrow.jsx": 6896,
	"./drugIcon.jsx": 9850,
	"./editIcon.jsx": 1460,
	"./editIconTable.jsx": 7422,
	"./excelIcon.jsx": 9921,
	"./exitCircleIcon.jsx": 2568,
	"./exitIcon.jsx": 8944,
	"./eyeClosedIcon.jsx": 4759,
	"./eyeIcon.jsx": 3187,
	"./eyeOpenIcon.jsx": 975,
	"./femaleIcon.jsx": 2068,
	"./flagIcon.jsx": 2910,
	"./flagIcon24.jsx": 2340,
	"./group.jsx": 6918,
	"./hospitalIcon.jsx": 5722,
	"./insuranceIcon.jsx": 3996,
	"./linkIcon.jsx": 4544,
	"./locationIcon24.jsx": 4155,
	"./lockIcon.jsx": 1993,
	"./lockIcon24.jsx": 8303,
	"./logoutIcon.jsx": 7326,
	"./maleIcon.jsx": 3111,
	"./mapMarkerIcon.jsx": 1660,
	"./maskIcon.jsx": 4016,
	"./medicalIcon.jsx": 7965,
	"./medicalRecordsIcon.jsx": 3445,
	"./newUsersIcon.jsx": 9238,
	"./newUsersIcon24.jsx": 4428,
	"./noteAddIcon.jsx": 5225,
	"./noteIcon.jsx": 3028,
	"./noteIcon24.jsx": 1710,
	"./notificationIcon.jsx": 4973,
	"./parvandeIcon.jsx": 1249,
	"./phoneIcon.jsx": 216,
	"./phoneIcon2.jsx": 7424,
	"./phoneIcon24.jsx": 1530,
	"./pillIcon.jsx": 9049,
	"./plusInage.jsx": 1750,
	"./printIcon.jsx": 1809,
	"./profileIcon.jsx": 2559,
	"./profileIcon24.jsx": 8401,
	"./profilePatientIcon.jsx": 6890,
	"./projectIcon.jsx": 2771,
	"./qrCodeIcon.jsx": 7002,
	"./referralIcon.jsx": 2211,
	"./registerAsGroupIcon.jsx": 3924,
	"./registerAsIndividualIcon.jsx": 5490,
	"./replacementIcon.jsx": 4183,
	"./reportIcon.jsx": 9341,
	"./reportIcon24.jsx": 7304,
	"./searchIcon.jsx": 7440,
	"./settingIcon.jsx": 9297,
	"./signInIcon.jsx": 3910,
	"./socialMedia.jsx": 2272,
	"./startAndStopIcon.jsx": 9315,
	"./supportIcon.jsx": 1949,
	"./tableIcon.jsx": 364,
	"./trackpadDeactiveIcon.jsx": 8635,
	"./trashIcon.jsx": 8298,
	"./trashIcon24.jsx": 824,
	"./universityCapIcon.jsx": 3872,
	"./universityIcon.jsx": 3392,
	"./uploadIcon.jsx": 9879,
	"./uploadIconParvandeh.jsx": 5932,
	"./userCheckIcon.jsx": 1543,
	"./userIcon.jsx": 6977,
	"./usersIcon.jsx": 2360,
	"./vector.jsx": 4650,
	"assets/SVG/MoneyIcon.jsx": 4976,
	"assets/SVG/PatientIcon.jsx": 3931,
	"assets/SVG/PlusIcon.jsx": 796,
	"assets/SVG/PlusIcon32.jsx": 1495,
	"assets/SVG/SurgeryIcon.jsx": 7241,
	"assets/SVG/TripIcon.jsx": 8269,
	"assets/SVG/TripIcon2.jsx": 7371,
	"assets/SVG/TripIcon24.jsx": 6971,
	"assets/SVG/accessibilityIcon.jsx": 944,
	"assets/SVG/addAccont.jsx": 6994,
	"assets/SVG/addAccont24.jsx": 3248,
	"assets/SVG/addGroupIcon.jsx": 7874,
	"assets/SVG/addPatientIcon.jsx": 272,
	"assets/SVG/addPhotoIcon.jsx": 2135,
	"assets/SVG/addProject.jsx": 1107,
	"assets/SVG/addUserIcon.jsx": 5772,
	"assets/SVG/adminIcon.jsx": 4573,
	"assets/SVG/allergyIcon.jsx": 888,
	"assets/SVG/avatarIcon.jsx": 1027,
	"assets/SVG/bloodType.jsx": 8203,
	"assets/SVG/bookmark.jsx": 2131,
	"assets/SVG/bookmarkIcon.jsx": 1496,
	"assets/SVG/borderIcon.jsx": 9370,
	"assets/SVG/calendarIcon.jsx": 2246,
	"assets/SVG/calendarIcon24.jsx": 9324,
	"assets/SVG/callIcon.jsx": 8348,
	"assets/SVG/clockIcon.jsx": 2142,
	"assets/SVG/closeIcon.jsx": 4276,
	"assets/SVG/collapseIcon.jsx": 5025,
	"assets/SVG/companyIcon.jsx": 2453,
	"assets/SVG/configIcon.jsx": 2862,
	"assets/SVG/dashboard.jsx": 3539,
	"assets/SVG/dayIcon.jsx": 4210,
	"assets/SVG/deleteIcon.jsx": 9577,
	"assets/SVG/dentalIcon.jsx": 8488,
	"assets/SVG/descriptionIcon.jsx": 6950,
	"assets/SVG/downArrow.jsx": 6896,
	"assets/SVG/drugIcon.jsx": 9850,
	"assets/SVG/editIcon.jsx": 1460,
	"assets/SVG/editIconTable.jsx": 7422,
	"assets/SVG/excelIcon.jsx": 9921,
	"assets/SVG/exitCircleIcon.jsx": 2568,
	"assets/SVG/exitIcon.jsx": 8944,
	"assets/SVG/eyeClosedIcon.jsx": 4759,
	"assets/SVG/eyeIcon.jsx": 3187,
	"assets/SVG/eyeOpenIcon.jsx": 975,
	"assets/SVG/femaleIcon.jsx": 2068,
	"assets/SVG/flagIcon.jsx": 2910,
	"assets/SVG/flagIcon24.jsx": 2340,
	"assets/SVG/group.jsx": 6918,
	"assets/SVG/hospitalIcon.jsx": 5722,
	"assets/SVG/insuranceIcon.jsx": 3996,
	"assets/SVG/linkIcon.jsx": 4544,
	"assets/SVG/locationIcon24.jsx": 4155,
	"assets/SVG/lockIcon.jsx": 1993,
	"assets/SVG/lockIcon24.jsx": 8303,
	"assets/SVG/logoutIcon.jsx": 7326,
	"assets/SVG/maleIcon.jsx": 3111,
	"assets/SVG/mapMarkerIcon.jsx": 1660,
	"assets/SVG/maskIcon.jsx": 4016,
	"assets/SVG/medicalIcon.jsx": 7965,
	"assets/SVG/medicalRecordsIcon.jsx": 3445,
	"assets/SVG/newUsersIcon.jsx": 9238,
	"assets/SVG/newUsersIcon24.jsx": 4428,
	"assets/SVG/noteAddIcon.jsx": 5225,
	"assets/SVG/noteIcon.jsx": 3028,
	"assets/SVG/noteIcon24.jsx": 1710,
	"assets/SVG/notificationIcon.jsx": 4973,
	"assets/SVG/parvandeIcon.jsx": 1249,
	"assets/SVG/phoneIcon.jsx": 216,
	"assets/SVG/phoneIcon2.jsx": 7424,
	"assets/SVG/phoneIcon24.jsx": 1530,
	"assets/SVG/pillIcon.jsx": 9049,
	"assets/SVG/plusInage.jsx": 1750,
	"assets/SVG/printIcon.jsx": 1809,
	"assets/SVG/profileIcon.jsx": 2559,
	"assets/SVG/profileIcon24.jsx": 8401,
	"assets/SVG/profilePatientIcon.jsx": 6890,
	"assets/SVG/projectIcon.jsx": 2771,
	"assets/SVG/qrCodeIcon.jsx": 7002,
	"assets/SVG/referralIcon.jsx": 2211,
	"assets/SVG/registerAsGroupIcon.jsx": 3924,
	"assets/SVG/registerAsIndividualIcon.jsx": 5490,
	"assets/SVG/replacementIcon.jsx": 4183,
	"assets/SVG/reportIcon.jsx": 9341,
	"assets/SVG/reportIcon24.jsx": 7304,
	"assets/SVG/searchIcon.jsx": 7440,
	"assets/SVG/settingIcon.jsx": 9297,
	"assets/SVG/signInIcon.jsx": 3910,
	"assets/SVG/socialMedia.jsx": 2272,
	"assets/SVG/startAndStopIcon.jsx": 9315,
	"assets/SVG/supportIcon.jsx": 1949,
	"assets/SVG/tableIcon.jsx": 364,
	"assets/SVG/trackpadDeactiveIcon.jsx": 8635,
	"assets/SVG/trashIcon.jsx": 8298,
	"assets/SVG/trashIcon24.jsx": 824,
	"assets/SVG/universityCapIcon.jsx": 3872,
	"assets/SVG/universityIcon.jsx": 3392,
	"assets/SVG/uploadIcon.jsx": 9879,
	"assets/SVG/uploadIconParvandeh.jsx": 5932,
	"assets/SVG/userCheckIcon.jsx": 1543,
	"assets/SVG/userIcon.jsx": 6977,
	"assets/SVG/usersIcon.jsx": 2360,
	"assets/SVG/vector.jsx": 4650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3350;